import { useState } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Refresh } from "@mui/icons-material";

export default function NameSearchComponent({ onSearch, placeholderName }) {
  // console.log("placeholderName: ", placeholderName);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    onSearch(searchTerm);
  };

  const handleReset = () => {
    setSearchTerm(""); // Clear the search input
    onSearch(""); // Trigger search without any query to reset the data
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      placeholder={`${placeholderName || "Search by name"}`}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      onKeyPress={(e) => {
        if (e.key === "Enter") {
          handleSearch();
        }
      }}
      InputProps={{
        endAdornment: (
          <Box>
            <InputAdornment position="end">
              {/* <Tooltip title="Search"> */}
              <IconButton onClick={handleSearch} disabled={!searchTerm}>
                <SearchIcon />
              </IconButton>
              {/* </Tooltip> */}

              <Tooltip title="Reset">
                <IconButton onClick={handleReset}>
                  <Refresh />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          </Box>
        ),
      }}
    />
  );
}

// import { useState } from 'react';
// import { TextField, InputAdornment, IconButton } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';

// export default function NameSearchComponent({ onSearch }) {
//   const [searchTerm, setSearchTerm] = useState('');

//   const handleSearch = () => {
//     onSearch(searchTerm);
//   };

//   return (
//     <TextField
//       size="small"
//       variant="outlined"
//       placeholder="Search..."
//       value={searchTerm}
//       onChange={(e) => setSearchTerm(e.target.value)}
//       onKeyPress={(e) => {
//         if (e.key === 'Enter') {
//           handleSearch();
//         }
//       }}
//       InputProps={{
//         endAdornment: (
//           <InputAdornment position="end">
//             <IconButton onClick={handleSearch}>
//               <SearchIcon />
//             </IconButton>
//           </InputAdornment>
//         ),
//       }}
//     />
//   );
// }
